import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LandingContent from "./landing/LandingContent";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import Doc from "./common/Doc";
import Pricing from "./price/Pricing";
import DeveloperContent from "./developer/DeveloperContent";
import DownloadContent from "./download/DownloadContent";
import SupportContent from "./support/SupportContent";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header />
        <Switch>
          <Route exact path="/" component={LandingContent} />
          <Route exact path="/developer" component={DeveloperContent} />
          <Route exact path="/download" component={DownloadContent} />
          <Route
            exact
            path="/terms-of-use"
            render={() => <Doc docName="terms_of_use" />}
          />
          <Route
            exact
            path="/privacy-policy"
            render={() => <Doc docName="privacy_policy" />}
          />
          <Route
            exact
            path="/licenses"
            render={() => <Doc docName="licenses" />}
          />
          <Route exact path="/price" component={Pricing} />
          <Route exact path="/support" component={SupportContent} />
          {/*<Route exact path="/developer/start" component={GetStartContent}/>*/}
          {/*<Route exact path="/developer/api" component={Unavailable}/>*/}
          {/*<Route exact path="/developer/integration" component={IntegrationContent}/>*/}
          {/*<Route exact path="/developer/link" component={LinkContent}/>*/}
          {/*<Route exact path="/developer/local" component={LocalContent}/>*/}
          {/*<Route exact path="/developer/automation" component={AutomationContent}/>*/}
          {/*<Route exact path="/reference" component={Unavailable}/>*/}
          {/*<Route exact path="/news" component={NewsContent} />*/}
          {/*<Route exact path="/news/:id" component={NewsArticle} />*/}
          {/*<Route exact path="/about/mission" component={MissionContent} />*/}
          {/*<Route exact path="/about/contact" component={ContactContent} />*/}
        </Switch>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
